"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseMenuDivider = function BaseMenuDivider() {
  return _react2.default.createElement("div", { className: "quiver-base-menu-divider" });
};

exports.default = BaseMenuDivider;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenuDivider/BaseMenuDivider.js
// module id = 523
// module chunks = 11